/* 
Copyright (c) Karsten Jeske and John Firth
This source code is licensed under the proprietary license found in the
LICENSE file in the root directory of this source tree.
*/

export const toDisplayDate = (
  value: { month: number; year: number } | null | undefined
): Date | null => {
  if (!value) return null
  const { month, year } = value
  if (typeof month !== "number" || typeof year !== "number" || month < 1 || month > 12) {
    return null
  }
  return new Date(year, month - 1, 1)
}
